import CategoryTable from "./components/CategoryTable";

const Tables = () => {
  return (
    <div>
      <div className="f mt-5 h-full w-full">
        <CategoryTable />
      </div>
    </div>
  );
};

export default Tables;
